import React, { useContext, useEffect, useRef, useState } from "react";
import { Collapse, Modal } from "react-bootstrap";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./Accordian.css";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  insertUpdateDashboardData,
  FileDownloadTestCaseIssue,
  FileDownloadTCEngagementDetails,
  isSaturdayOrWeekendForDashboard,
} from "../../../Helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import { BsExclamationCircle } from "react-icons/bs";
import axios from "axios"; //Amogh
import fileDownload from "js-file-download"; //Amogh
import { FaDownload } from "react-icons/fa6"; //Amogh
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { Tooltip } from "antd";

const Accordian4 = ({
  data: mainData,
  TCstatusDropdown,
  TCnatureOfIssueDropdown,
  setDashboardData,
  totalReportedHoursToday,
  backdatedDate,
  backDatedStatus,
  resourceAllocate
}) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { EmployeeId } = getContext();

  //component state
  const [data, setData] = useState(mainData);
  let [fileUrl, setFileUrl] = useState(null); //Amogh
  const [SharePointLink, setSharePointLink] = useState(""); // Amogh

  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationModalReturnValue, setConfirmationModalReturnValue] =
    useState(false);

  const [isNotWorkingDay, setIsNotWorkingDay] = useState(false); //Deepak Gupta
  const [showConfirmationForDate, setShowConfirmationForDate] = useState(false); //Deepak Gupta
  const [confirmationForDateModal, setConfirmationForDateModal] =
    useState(false); //Deepak Gupta

  const closeConfirmationModal = (confirmation) => {
    if (confirmation) {
      setConfirmationModalReturnValue(confirmation);
    }
    setShowConfirmationModal(false);
  };

  // Download modal state
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const customColors = ["#2755f3"];

  const downloadOptions = {
    selectableRows: "none",
    count: false,
    rowsPerPage: false,
    serverSide: false,
    rowsPerPageOptions: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false,
    setCellHeaderProps: () => ({ align: "center" }),
  };

  const AttachmentsGridColumns = [
    { name: "engagement", label: "Engagement", options: { display: false } },
    { name: "document", label: "TestCaseIssue Name", options: { display: true } },
    { name: "fileUrl", label: "FileUrl", options: { display: false } },
    { name: "testcaseid", label: "TestCase", options: { display: false,customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1, } },
    { name: "createdDate", label: "Created Date", options: { display: true } },
    {
      name: "",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const engagement = tableMeta.rowData[0];
          const fileUrl = tableMeta.rowData[2];
          const testcaseid = tableMeta.rowData[3];
          return (
            <div>
              <Tooltip title="Download" color={customColors[0]}>
                <a
                  className="action_icon"
                  onClick={() => handleDownload(fileUrl, engagement, testcaseid, testcaseid)}
                >
                  <i className="fa-solid fa-download" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </div>
          );
        },
      },
    },
  ];

  //Added by Deepak Gupta
  const closeConfirmationModalForDate = (confirmation) => {
    if (confirmation) {
      setConfirmationForDateModal(confirmation);
    }
    setShowConfirmationForDate(false);
  };

  //Added by Deepak Gupta
  const getIsSaturdayOrWeekendForDashboard = async () => {
    let now = new Date().getHours();

    let timesheetDateToBe;
    /**
     *  check if value in now is between 12am and 6am
     *  12am -> 0
     *  6am -> 6
     */
    if (backDatedStatus) {
      timesheetDateToBe = moment(backdatedDate).format(moment.HTML5_FMT.DATE);
    } else {
      if (now >= 0 && now <= 6) {
        timesheetDateToBe = moment(new Date())
          .subtract(1, "day")
          .format(moment.HTML5_FMT.DATE);
      } else {
        timesheetDateToBe = moment(new Date()).format(moment.HTML5_FMT.DATE);
      }
    }

    let postObject = {
      assignedTo: resourceAllocate.value,
      timesheetDateToBe: timesheetDateToBe,
    };
    const { data } = await APICall(
      isSaturdayOrWeekendForDashboard,
      "POST",
      postObject
    );
    // console.log("==>", data.isNotWorkingDay);
    // if (data !== undefined && data.length > 0) {
    setIsNotWorkingDay(data.isNotWorkingDay);
    //console.log("Hello=>" + isNotWorkingDay);
    //}
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      ticketNatureOfIssue: data.ticketNatureOfIssue,
    }));
  }, []);

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "status") {
      if (event.id === 23) {
        hoursSpentRef.current.innerText = 0;
        setData((prev) => {
          return {
            ...prev,
            actualEndDate: null,
          };
        });
      } else if (event.id === 22) {
        if (data.actualStartDate === null) {
          setData((prev) => {
            return {
              ...prev,
              actualStartDate: new Date(),
            };
          });
        }
      } else if (event.id === 24) {
        if (data.actualEndDate === null && data.actualStartDate === null) {
          setData((prev) => {
            return {
              ...prev,
              actualStartDate: new Date(),
              actualEndDate: new Date(),
            };
          });
        } else if (
          data.actualEndDate === null &&
          data.actualStartDate !== null
        ) {
          setData((prev) => {
            return {
              ...prev,
              actualEndDate: new Date(),
            };
          });
        }
      } else {
        setData((prev) => {
          return {
            ...prev,
            actualEndDate: null,
            actualStartDate: null,
          };
        });
      }
      setData((prev) => {
        return {
          ...prev,
          status: event,
        };
      });
    }
    if (apiFieldName === "nature") {
      setData((prev) => {
        return {
          ...prev,
          ticketNatureOfIssue: event,
        };
      });
    }
  };

  const hoursSpentRef = useRef<any>();

  useEffect(() => {
    getIsSaturdayOrWeekendForDashboard(); //Deepak Gupta
    hoursSpentRef.current.innerText = data.todayHoursSpent;
  }, []);

  useEffect(() => {
    hoursSpentRef.current.innerText = data.todayHoursSpent;
  }, [backdatedDate]);

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "thoursSpent") {
    }
    if (apiFieldName === "actualStartDate") {
      setData((prev) => {
        return {
          ...prev,
          actualStartDate: event,
        };
      });
    }
    if (apiFieldName === "remarks") {
      setData((prev) => {
        return {
          ...prev,
          remarks: event.target.value,
        };
      });
    }
    if (apiFieldName === "actualEndDate") {
      setData((prev) => {
        return {
          ...prev,
          actualEndDate: event,
        };
      });
    }
  };

  const checkValidation = (data) => {
    let validator = true;
    if (data.todayHoursSpent === null || data.todayHoursSpent < 0) {
      validator = false;
    }
    // else if (
    //   data.ticketNatureOfIssue === null ||
    //   data.ticketNatureOfIssue === undefined
    // ) {
    //   validator = false;
    // }
    else if (data.status.id === 22) {
      if (data.actualStartDate === null || data.todayHoursSpent === null) {
        validator = false;
      }
    } else if (data.status.id === 24) {
      if (data.actualEndDate === null || data.todayHoursSpent === null) {
        validator = false;
      }
    }
    return validator;
  };
  const updateData = async (data) => {
    let now = new Date().getHours();

    let timesheetDateToBe;
    /**
     *  check if value in now is between 12am and 6am
     *  12am -> 0
     *  6am -> 6
     */
    if (backDatedStatus) {
      timesheetDateToBe = moment(backdatedDate).format(moment.HTML5_FMT.DATE);
    } else {
      if (now >= 0 && now <= 6) {
        timesheetDateToBe = moment(new Date())
          .subtract(1, "day")
          .format(moment.HTML5_FMT.DATE);
      } else {
        timesheetDateToBe = moment(new Date()).format(moment.HTML5_FMT.DATE);
      }
    }

    let obj = {
      id: data.id,
      todayHoursSpent: isNaN(parseFloat(hoursSpentRef.current.innerText))
        ? null
        : parseFloat(hoursSpentRef.current.innerText),
      actualStartDate: data.actualStartDate
        ? moment(data.actualStartDate).format(moment.HTML5_FMT.DATE)
        : moment(new Date()).format(moment.HTML5_FMT.DATE),
      actualEndDate: data.actualEndDate
        ? moment(data.actualEndDate).format(moment.HTML5_FMT.DATE)
        : null,
      remarks: data.remarks,
      timesheetDateToBe: timesheetDateToBe,
      status: data.status.id,
      assignedTo: EmployeeId,
      rType: "TestCaseIssue",
      ticketNatureOfIssue: data.ticketNatureOfIssue.id,
      BackDatedStatus: backDatedStatus,
    };

    let isMax = false;
    let isNegative = false;

    // to check if totalreportedToday is > 16
    setDashboardData((prev) => {
      if (
        obj.todayHoursSpent < 0
        // || obj.todayHoursSpent === null
      ) {
        isNegative = true;
        return prev;
      } else {
        let newData = prev.map((ele) => {
          if (ele.id === data.id) {
            if (ele.todayHoursSpent === null) {
              return {
                ...ele,
                todayHoursSpent: parseFloat(hoursSpentRef.current.innerText),
              };
            } else {
              return {
                ...ele,
                todayHoursSpent:
                  parseFloat(ele.todayHoursSpent) +
                  parseFloat(hoursSpentRef.current.innerText),
              };
            }
          } else {
            return ele;
          }
        });
        let total = newData.reduce(
          (sum, data) => (sum = sum + data.todayHoursSpent),
          0
        );
        if (total > 16) {
          isMax = true;
          return prev;
        } else {
          isMax = false;
          return prev;
        }
      }
    });

    if (isNegative) {
      notify(1, "Invalid Data!");
    } else if (isMax) {
      notify(1, "Hours cannot be greater than 16");
    } else {
      let validate = checkValidation(obj);

      if (validate) {
        // notify(0, "success");
        showLoader();
        const res = await APICall(insertUpdateDashboardData, "Post", obj);
        hideLoader();
        if (res.status === 1) {
          notify(res.status, res.message);
        } else {
          setIsActive(!isActive);
          notify(0, "Hours updated successfully!");
          // update actual today hours
          setData((prev) => {
            if (prev.todayHoursSpent === null) {
              return {
                ...prev,
                todayHoursSpent: parseFloat(hoursSpentRef.current.innerText),
              };
            } else {
              return {
                ...prev,
                todayHoursSpent:
                  parseFloat(prev.todayHoursSpent) +
                  parseFloat(hoursSpentRef.current.innerText),
              };
            }
          });

          // update total today hours
          setDashboardData((prev) => {
            return prev.map((ele) => {
              if (ele.id === data.id) {
                if (ele.todayHoursSpent === null) {
                  return {
                    ...ele,
                    todayHoursSpent: parseFloat(
                      hoursSpentRef.current.innerText
                    ),
                  };
                } else {
                  return {
                    ...ele,
                    todayHoursSpent:
                      parseFloat(ele.todayHoursSpent) +
                      parseFloat(hoursSpentRef.current.innerText),
                  };
                }
              } else {
                return ele;
              }
            });
          });
        }
      } else {
        notify(1, "Please fill required field!");
      }
    }
  };


  const handleFileUrlClick = (url, engagement, testcaseid, createdDate) => {
    setIsDownloadModalOpen(true);
    const fileUrls = url.split(",");
    console.log(fileUrls)
    let formattedDate = moment().startOf("year").format("DD-MMMM-YYYY");
    const downloadItems = fileUrls.map((fileUrl, index) => (
      {
      engagement: engagement,
      fileUrl: fileUrl,
      testcaseid: testcaseid,
      createdDate: formattedDate,
      document: `${fileUrl.replace(/.*file=/, "") 
      .replace(/_TestCaseIssue_.*$/, "") 
      .replace(/.*\//, "")
      .replace(/%20/g, " ")}_TestCaseIssue_${testcaseid}_${index + 1}`,
    }));
    setDownloadData(downloadItems);
  };


  // const handleDownload = async (testcaseid) => {
    

  //   const postObject = {
  //     id: testcaseid, // Use a comma instead of a semicolon
  //   };

  //   const { data } = await APICall(
  //     FileDownloadTCEngagementDetails,
  //     "POST",
  //     postObject
  //   );
    

  //   if (data.fileUrl !== null) {
  //     // console.log("defender");
  //     setFileUrl(data.fileUrl);
  //   }
    

  //   const requestObjectForDownload = {
  //     Customer: data.engagement,
  //     FileUrl: data.fileUrl, // Use latest fileUrl directly
  //   };

    

  //   if (requestObjectForDownload.FileUrl) {
  //     axios
  //       .request({
  //         responseType: "blob",
  //         method: "POST",
  //         url: FileDownloadTestCaseIssue,
  //         data: requestObjectForDownload,
  //         headers: {
  //           "Access-Control-Allow-Origin": "*",
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Headers": "*",
  //         },
  //       })
  //       .then((response) => {
  //         const contentDisposition = response.headers["content-disposition"];

  //         const filenameRegex = /filename[^;=\n]=((['"]).?\2|[^;\n]*)/;
  //         const matches = filenameRegex.exec(contentDisposition);

  //         let filename = "";
  //         if (matches && matches[1]) {
  //           filename = matches[1].replace(/['"]/g, "");
  //         }

  //         const fileExtension = filename.substring(filename.lastIndexOf("."));

  //         if (filename === "Doc.aspx") {
  //           // For .docx file download
  //           const docxFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.doc`;
  //           fileDownload(response.data, docxFileName);
  //         } else if (fileExtension === "pdf") {
  //           // For .pdf file download
  //           const pdfFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.pdf`;
  //           fileDownload(response.data, pdfFileName);
  //         } else if (fileExtension === "doc") {
  //           // For .doc file download
  //           const docFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.doc`;
  //           fileDownload(response.data, docFileName);
  //         } else if (fileExtension === "png") {
  //           // For .png file download
  //           const pngFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.png`;
  //           fileDownload(response.data, pngFileName);
  //         } else if (fileExtension === "jpeg") {
  //           // For .jpeg or .jpg file download
  //           const jpegFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.jpeg`;
  //           fileDownload(response.data, jpegFileName);
  //         } else if (fileExtension === "jpg") {
  //           const jpgFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.jpg`;
  //           fileDownload(response.data, jpgFileName);
  //         } else if (fileExtension === "ppt" || fileExtension === "pptx") {
  //           // For .ppt or .pptx file download
  //           const pptFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.pptx`;
  //           fileDownload(response.data, pptFileName);
  //         } else if (fileExtension === "xlsx") {
  //           // For .xlsx file download
  //           const xlsxFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.xlsx`;
  //           fileDownload(response.data, xlsxFileName);
  //         } else if (fileExtension === "eml") {
  //           // For .eml file download
  //           const emlFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.eml`;
  //           fileDownload(response.data, emlFileName);
  //         } else if (fileExtension === "docx") {
  //           // For .eml file download
  //           const docxFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format("DD/MMMM/YYYY")}.docx`;
  //           fileDownload(response.data, docxFileName);
  //         } else {
  //           // For unhandled file types, use the extension dynamically
  //           const defaultFileName = `${data.engagement}-TestIssue-${
  //             postObject.id
  //           }-${moment(data.createdDate).format(
  //             "DD/MMMM/YYYY"
  //           )}.${fileExtension}`;
  //           fileDownload(response.data, defaultFileName);
  //         }
  //       })
  //       .catch((error) => {
  //         notify(1, "File not found or an error occurred during the download.");
  //         console.error("Error Response:", error.response?.data);
  //       });
  //   } else {
  //     console.log("Skipping axios request because FileUrl is missing or null.");
  //   }
  // };


  const handleDownload = async (fileUrl, engagement, testcaseid, meta) => {
    // Remove everything after "&action=" in the URL
    const cleanFileUrl = fileUrl.split("&action=")[0];

    const requestObjectForDownload = {
      Customer: engagement,
      FileUrl: cleanFileUrl,
    };

    // console.log(
    //   "Sending request to FileDownloadTestCaseIssue:",
    //   requestObjectForDownload
    // );

    try {
      const response = await axios.request({
        responseType: "blob",
        method: "POST",
        url: FileDownloadTestCaseIssue,
        data: requestObjectForDownload,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      });


      // const downloadOptions = {
      //   selectableRows: "none",
      //   count: false,
      //   rowsPerPage: false,
      //   serverSide: false,
      //   rowsPerPageOptions: false,
      //   download: false,
      //   print: false,
      //   viewColumns: false,
      //   filter: false,
      //   search: false,
      //   pagination: false,
      //   setCellHeaderProps: () => ({ align: "center" }),
      // };
    
      // const AttachmentsGridColumns = [
      //   {
      //     name: "engagement",
      //     label: "Engagement",
      //     options: { display: false },
      //   },
      //   {
      //     name: "document",
      //     label: "TestCaseIssue Name",
      //     options: { display: true },
      //   },
      //   {
      //     name: "fileUrl",
      //     label: "FileUrl",
      //     options: { display: false },
      //   },
      //   {
      //     name: "testcaseid",
      //     label: "TestCase ID",
      //     options: { display: true },
      //   },
      //   {
      //     name: "createdDate",
      //     label: "Created Date",
      //     options: { display: true },
      //   },
      //   {
      //     name: "",
      //     label: "Action",
      //     options: {
      //       sort: false,
      //       filter: false,
      //       display: true,
      //       customBodyRender: (value, tableMeta) => {
      //         const engagement = tableMeta.rowData[0];
      //         const fileUrl = tableMeta.rowData[2];
      //         const testcaseid = tableMeta.rowData[3];
    
      //         return (
      //           <div>
      //             <Tooltip title="Download" color={customColors[0]}>
      //               <a
      //                 className="action_icon"
      //                 onClick={() =>
      //                   handleDownload(fileUrl, engagement, testcaseid)
      //                 }
      //               >
      //                 <i className="fa-solid fa-download" aria-hidden="true"></i>
      //               </a>
      //             </Tooltip>
      //             {/* <Tooltip title="View" color={customColors[0]}>
      //             <a
      //               className="action_icon"
      //               href={fileUrl}
      //               target="_blank"
      //               rel="noopener noreferrer"
      //               style={{ marginLeft: "10px" }}
      //             >
      //               <i className="fa-solid fa-eye" aria-hidden="true"></i>
      //             </a>
      //           </Tooltip> */}
      //           </div>
      //         );
      //       },
      //     },
      //   },
      // ];
    

      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers["content-disposition"];
      //console.log("Content-Disposition Header:", contentDisposition);

      let filename = "";
      if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      filename = filename.replace(/_TestCaseIssue.*/, "");
      const match = fileUrl.replace(/^.*?TestCaseIssue_\d+_/, "").replace(/_\d{1,2}-[A-Za-z]+-\d{4}\.pdf$/, "");// Find the last number before non-digit characters
    //const specificNumber = numberMatch ? numberMatch[1] : '';
      //console.log('FileName ===>',filename)
      //console.log('NumberMatch ===>',match)
      //console.log('SpecificNumber ===>',specificNumber) 

      // Function to extract file extension
      const getFileExtension = (filename) =>
        filename.split(".").pop().toLowerCase();

      // If filename is missing or incorrect, extract it from FileUrl
      if (!filename || filename === "Doc.aspx") {
        filename = cleanFileUrl.split("/").pop();
      }

      // Extract file extension
      const fileExtension = getFileExtension(filename);

      // Generate formatted filename
      const formattedDate = moment().format("DD-MMMM-YYYY"); // Use current date
      let downloadFileName = `${filename}-TestCaseIssue-${testcaseid}-${match}.${fileExtension}`;

      // Ensure correct file extension mapping (if needed)
      const validExtensions = [
        "pdf",
        "doc",
        "docx",
        "png",
        "jpeg",
        "jpg",
        "ppt",
        "pptx",
        "xlsx",
        "xls",
        "eml",
      ];
      if (!validExtensions.includes(fileExtension)) {
        downloadFileName = `${filename}_TestCaseIssue_${testcaseid}_${match}`;
      }

     // console.log("Downloading file as:", downloadFileName);

      // Download the file
      fileDownload(response.data, downloadFileName);
    } catch (error) {
      notify(1, "File not found or an error occurred during the download.");
      console.error("Error Response:", error.response?.data);
    }
  };
  useEffect(() => {
    if (confirmationModalReturnValue) {
      updateData(data);
    }
    setConfirmationModalReturnValue(false);
    if (confirmationForDateModal) {
      //Deepak Gupta
      updateData(data);
    }
    setConfirmationForDateModal(false);
  }, [confirmationModalReturnValue, confirmationForDateModal]);

  return (
    <>
      {data && (
        <>
          <div className="main-cardtest card">
            <div
              style={{ backgroundColor: "#e9ecef !important" }}
              className="card-header"
              id="headingOne"
              onClick={() => setIsActive(!isActive)}
            >
              <div data-toggle="collapse" data-target="#collapseOne">
                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0">
                    {/* check status then render */}

                    {data.status.id === 24 && (
                      <i
                        className="fa fa-check-circle mr-2"
                        aria-hidden="true"
                      ></i>
                    )}
                    {data.status.id === 22 && (
                      <i
                        className="fa fa-hourglass-end mr-2 yellow-col"
                        aria-hidden="true"
                      ></i>
                    )}
                    {/* {data.status === 24 && (
                      <i
                        className="fa fa-check-circle mr-2"
                        aria-hidden="true"
                      ></i>
                    )}
                    {data.status === 22 && (
                      <i
                        className="fa fa-hourglass-end mr-2 yellow-col"
                        aria-hidden="true"
                      ></i>
                    )} */}
                    {data.title}
                    <span className="float-right">
                      {" "}
                      <i className="fa fa-chevron-down"></i>{" "}
                    </span>
                  </div>
                </div>

                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0 mt-2 sub-text">
                    <span>
                      {moment(data.plannedEndDate).isBefore(
                        moment(),
                        "day"
                      ) && (
                        <i
                          className="fa fa-fire mr-2 red-col"
                          aria-hidden="true"
                        ></i>
                      )}
                      {data.plannedEndDate.toDateString() ===
                        new Date().toDateString() && (
                        <i
                          className="fa-solid fa-bookmark mr-2 yellow-col"
                          aria-hidden="true"
                        ></i>
                      )}
                      {data.engagement &&
                        data.phaseName === null &&
                        data.applicationName === null && <>{data.engagement}</>}
                      {data.engagement && data.phaseName && (
                        <>
                          {data.engagement} - {data.phaseName}
                        </>
                      )}
                      {data.engagement && data.applicationName && (
                        <>
                          {data.engagement} - {data.applicationName}
                        </>
                      )}
                      {/* {data.engagement && (
                    <>
                      {data.engagement}
                    </>)} */}
                    </span>
                    <span className="float-right red-col">
                      {data.todayHoursSpent ? data.todayHoursSpent : 0}
                      <span className="black-col">/{data.hoursAssigned}H</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Collapse in={isActive}>
              <div>
                <>
                  {/* for TestCase Dev Screen */}
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                  >
                    <div
                      className="card-bodytest card-body"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          {data.id} - {""}
                          {data.title}
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Status</label>
                            <SelectForm
                              options={TCstatusDropdown}
                              placeholder="Select"
                              isDisabled={false}
                              value={data.status}
                              onChange={(event) =>
                                selectOnChange(event, "status")
                              }
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                              getOptionLabel={(options) => options.value}
                              getOptionValue={(options) => options.id}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Classification</label>
                            <SelectForm
                              options={TCnatureOfIssueDropdown}
                              placeholder="Select"
                              isDisabled={false}
                              value={data.ticketNatureOfIssue}
                              onChange={(event) =>
                                selectOnChange(event, "nature")
                              }
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                              getOptionLabel={(options) => options.value}
                              getOptionValue={(options) => options.id}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Test Case Title</label>
                            <InputForm
                              placeholder={""}
                              isDisabled={true}
                              textArea={true}
                              className="numLeft"
                              value={data.description}
                              onChange={(e) =>
                                handleTextEvent(e, "TestCaseTitle")
                              }
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table
                              className="table table-bordered table_grid"
                              id="time-table"
                            >
                              <thead>
                                <tr>
                                  <th className=""></th>
                                  <th className="">Actual Start </th>
                                  <th className="">Actual End</th>
                                  <th className=""></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Date</td>
                                  <td className="disabledEvent">
                                    <div className="">
                                      <div className="form-group">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                        >
                                          <DatePicker
                                            label="Date"
                                            value={data.actualStartDate}
                                            onChange={(e) =>
                                              handleTextEvent(
                                                e,
                                                "actualStartDate"
                                              )
                                            }
                                            inputFormat="dd/MM/yyyy"
                                            renderInput={(params) => (
                                              <TextField
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    </div>
                                  </td>

                                  <td className={"disabledEvent"}>
                                    <div className="">
                                      <div className="form-group">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                        >
                                          <DatePicker
                                            label="Date"
                                            value={data.actualEndDate}
                                            onChange={(e) =>
                                              handleTextEvent(
                                                e,
                                                "actualEndDate"
                                              )
                                            }
                                            inputFormat="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            renderInput={(params) => (
                                              <TextField
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    </div>
                                  </td>
                                  <td className={"disabledEvent"}></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="table-responsive">
                            <table
                              className="table table-bordered table_grid"
                              id="time-table"
                            >
                              <thead>
                                <tr>
                                  <th className=""></th>
                                  <th className="">Planned </th>
                                  <th className="">Actual</th>
                                  <th className="">Today</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Hours Spent</td>
                                  <td className="disabledEvent numRight">
                                    {data.hoursAssigned}
                                    {/* {<>Ues Testcase assigned hrs</>} */}
                                  </td>
                                  <td className="disabledEvent numRight">
                                    {data.hoursSpent}
                                    {/* {<>Hrs spent here</>} */}
                                  </td>
                                  <td
                                    className={
                                      data.status.id === 23
                                        ? "disabledEvent numRight"
                                        : "numRight"
                                    }
                                    contentEditable={
                                      data.status.id === 23 ? false : true
                                    }
                                    ref={hoursSpentRef}
                                    onInput={(e) =>
                                      handleTextEvent(
                                        e.currentTarget.textContent,
                                        "thoursSpent"
                                      )
                                    }
                                  ></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Remarks</label>
                            <InputForm
                              placeholder={""}
                              isDisabled={false}
                              textArea={true}
                              value={data.remarks ? data.remarks : ""}
                              onChange={(e) => handleTextEvent(e, "remarks")}
                            />
                          </div>
                        </div>
                        {data.sharePointLink !== null && (
                              <a
                                className="mr-2"
                                onClick={() =>
                                  handleFileUrlClick(
                                    data.sharePointLink,
                                    data.engagement,
                                    data.id,
                                    data.createdDate
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <i className="fa fa-download mr-1"></i>
                                Attachments
                              </a>
                            )}

                        <div className="col-lg-12">
                          {/* <div className="float-left fill-hours">
                                   <a className="mr-2">
                                  {" "}
                                  <i className="fa fa-file-alt mr-1"></i>
                                  RCA{" "}
                                </a> 
                                  <a>
                                    {" "}
                                    <i className="fa fa-clock mr-1"></i> History{" "}
                                  </a>
                                </div> */}
                          <div className="float-right fillUpdate">
                            {/* <button className="btn btn-reset ml-1">
                                  Reset
                                </button> */}
                            <button
                              style={{}}
                              //style={{ background: "#212529", color:"white" }}
                              disabled={
                                (data.status.id === 16 ? true : false) ||
                                (totalReportedHoursToday >= 16 ? true : false)
                                //||
                                //(futureDate ? true : false)
                              }
                              className="btn btn-update"
                              onClick={() => {
                                let todayHoursSpent = isNaN(
                                  parseFloat(hoursSpentRef.current.innerText)
                                )
                                  ? null
                                  : parseFloat(hoursSpentRef.current.innerText);

                                if (isNotWorkingDay) {
                                  //Deepak Gupta
                                  setShowConfirmationForDate(true);
                                } else if (todayHoursSpent > 9) {
                                  setShowConfirmationModal(true);
                                } else {
                                  updateData(data);
                                }
                              }}
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </Collapse>
          </div>
          <>
           {/* Download Modal */}
           <Modal
            show={isDownloadModalOpen}
            onHide={() => setIsDownloadModalOpen(false)}
            backdrop="static"
            keyboard={false}
            centered
            scrollable={true}
            size="lg"
            style={{ zIndex: 1050 }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Attachments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-lg-12">
                  <DynamicGrid
                    columns={AttachmentsGridColumns}
                    data={downloadData}
                    options={downloadOptions}
                  />
                </div>
                <div className="col-lg-12 mt-3">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => setIsDownloadModalOpen(false)}
                      className="btn btn-reset"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
            <Modal
              show={showConfirmationModal}
              onHide={() => closeConfirmationModal(false)}
              backdrop="static"
              keyboard={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Confirmation <BsExclamationCircle color="yellow" />
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>You entered hours more than 9</p>
                <p>Do you want to continue?</p>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => closeConfirmationModal(false)}
                  className="btn btn-reset"
                >
                  No
                </button>
                <button
                  onClick={() => closeConfirmationModal(true)}
                  className="btn btn-submit"
                >
                  Yes
                </button>
              </Modal.Footer>
            </Modal>
          </>

          {/*Added by Deepak Gupta*/}
          <>
            <Modal
              show={showConfirmationForDate}
              onHide={() => closeConfirmationModalForDate(false)}
              backdrop="static"
              keyboard={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title className="d-flex justify-content-center align-items-center gap-2">
                  Confirmation <BsExclamationCircle color="yellow" />
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>You are filling timesheet on Non-Working day</p>
                <p>Do you want to continue?</p>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => closeConfirmationModalForDate(false)}
                  className="btn btn-reset"
                >
                  No
                </button>
                <button
                  //style={{ background: "#96c61c" }}
                  onClick={() => closeConfirmationModalForDate(true)}
                  className="btn btn-submit"
                >
                  Yes
                </button>
              </Modal.Footer>
            </Modal>
          </>
        </>
      )}
    </>
  );
};

export default Accordian4;
